import { render, staticRenderFns } from "./OceanBase.vue?vue&type=template&id=39121854"
import script from "./OceanBase.vue?vue&type=script&lang=js"
export * from "./OceanBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports